export function getEmployeeEmail(employee: LSEmployee): string {
  const emailsObj = employee.Contact?.Emails;
  if (typeof emailsObj === 'string' || !emailsObj) {
    return '';
  }

  const emails = emailsObj.ContactEmail;
  if (Array.isArray(emails)) {
    const primary = emails.find((email) => email.useType === 'Primary');
    return primary?.address || emails[0]?.address || '';
  }

  return emails?.address || '';
}
